import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Cache data for 5 minutes by default
      staleTime: 1000 * 60 * 5, // 5 minutes
      // Keep data in cache for 10 minutes
      gcTime: 1000 * 60 * 10, // 10 minutes (formerly cacheTime)
      // Retry failed requests
      retry: (failureCount, error) => {
        // Don't retry for authentication errors
        if (error instanceof Error && error.message.includes('Authentication')) {
          return false;
        }
        // Retry up to 2 times for other errors
        return failureCount < 2;
      },
      // Refetch on window focus for important data
      refetchOnWindowFocus: true,
      // Don't refetch on reconnect to avoid spam
      refetchOnReconnect: false,
      // Refetch interval for critical data (disabled by default)
      refetchInterval: false,
    },
    mutations: {
      // Retry mutations once
      retry: 1,
    },
  },
});

// Query keys for consistent cache management
export const queryKeys = {
  // Plans related queries
  plans: ['plans'] as const,
  userPlan: ['user-plan'] as const,
  
  // API keys related queries  
  apiKeys: ['api-keys'] as const,
  
  // Usage related queries
  usage: ['usage'] as const,
  
  // Auth related queries
  auth: ['auth'] as const,
} as const;